import { Injectable } from "@angular/core";
import { DataStore } from "../shared/models/DataStore";

@Injectable()
export class RequestStore extends DataStore {
    constructor() {
        super();
    }

    public initializeStore() {
        this.set('request', null);
    }
}
